import React, { useState } from "react";
import { Fade } from 'react-awesome-reveal';
import { Form, Radio, Rate, Input, Button } from 'antd';
import PropTypes from 'prop-types';
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";

const EvaluationQuestion = ({ question, onAnswer, buildPayload, payload, onFinish, finishedEvaluation, sentEvaluation }) => {
  // const [disableComment, setDisableComment] = useState(payload.sendComment ? !payload.sendComment : true);
  const [disableComment, setDisableComment] = useState(true);
  const [disableSendButton, setDisableSendButton] = useState('');
  const [valueComment, setValueComment] = useState('');
  const [loading, setLoading] = useState(false);
  const radioStyle = { display: 'block' };
  const { TextArea } = Input;

  const getAnswerSelected = (answer) => {
    setTimeout(() => onAnswer(answer), 200);
  };

  const sendComment = (answer) => {
    if (answer.value === true) {
      setDisableComment(false);
      setDisableSendButton(false);
    } else {
      setDisableComment(true);
      setDisableSendButton(true);
      setValueComment('')
      buildPayload({ field: 'comment' }, { value: null })
    }
  }

  const sendEvaluation = async () => {
    setLoading(true);
    setDisableComment(true);
    
    setTimeout(() => {
      setLoading(false)
      onFinish()
      finishedEvaluation(true)
    }, 2000);
  };

  const renderQuestion = (_question) => {
    let component = null;

    if (_question.type === "check") {
      if (payload.comment) {
        buildPayload({ field: 'comment' }, { value: null })
      }
      component = 
        <Radio.Group >
          {_question.answers.map((answer) => (
            <Radio
              key={answer.order}
              value={answer.order}
              onClick={() => {
                getAnswerSelected(answer)
                buildPayload(_question, answer)
              }}
              style={radioStyle}
            >
              {answer.title}
            </Radio>
          ))}
        </Radio.Group>
    } else if (_question.type === "rate") {
      component = 
        <span>
          <Rate 
            onChange={(value) => {
              getAnswerSelected(value)
              buildPayload(_question, null, value)
            }} 
            value={payload.isSatisfied ? payload.isSatisfied : _question.value} 
          />
        </span>
    } else if (_question.type === "check&textarea") {
      component = 
        <div>
          <Radio.Group >
            {_question.answers.map((answer) => (
              <Radio 
                key={answer.order} 
                value={answer.order} 
                onClick={() => {
                  getAnswerSelected(answer)
                  buildPayload(_question, answer)
                  sendComment(answer)
                }}
                style={radioStyle} 
              >
                {answer.title}
              </Radio>
            ))}
          </Radio.Group>
          <TextArea 
            style={{ marginBottom: 20, marginTop: 20 }} 
            rows={6} 
            value={valueComment}
            onChange={(e) => {
              setDisableSendButton(e.target.value)
              setValueComment(e.target.value)
              buildPayload({ field: 'comment' }, { value: e.target.value })
            }}
            disabled={disableComment} 
          />
          <Button 
            type="primary" 
            htmlType="submit" 
            onClick={() => {
              sendEvaluation()
            }} 
            disabled={!disableSendButton} 
            block 
          >
            {loading && <LoadingOutlined style={{ marginRight: "5px" }} />}
            {loading && <span>Enviando...</span>}
            {!loading && <span>Enviar evaluación</span>}
          </Button>
        </div>
    }

    return (
      <Form.Item name={`answer-${_question.order}`}>
        {component}
      </Form.Item>
    )
  };

  return (
    <>
      {sentEvaluation && 
        <Form.Item style={{ textAlign: 'center'}}>
          <p><b>Evaluación enviada con éxito</b></p>
          <CheckCircleOutlined style={{ fontSize: '100px', color: '#52c41a', marginBottom: 20 }} />
          <p>¡Muchas gracias por ayudarnos a mejorar!</p>
          <Button type="primary" onClick={() => { window.close() }} >
            Salir
          </Button>
        </Form.Item>
      }

      {!sentEvaluation && 
        <Form.Item>
          <p><b>{ question.title }</b></p>
          <Fade>{ renderQuestion(question) }</Fade>
        </Form.Item>
      }
    </>
  )
}

EvaluationQuestion.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    order: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        order: PropTypes.number.isRequired,
        score: PropTypes.number.isRequired,
      })
    ),
  }).isRequired,
  onAnswer: PropTypes.func.isRequired,
  buildPayload: PropTypes.func.isRequired,
  payload: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  finishedEvaluation: PropTypes.func.isRequired,
  sentEvaluation: PropTypes.func.isRequired
};

export default EvaluationQuestion;